import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { userGroup } from "../app/schema";

export const GET_USER_GROUPS = "GET_USER_GROUPS";
export const GET_USER_GROUPS_SUCCESS = "GET_USER_GROUPS_SUCCESS";
export const GET_USER_GROUPS_ERROR = "GET_USER_GROUPS_ERROR";

export const GET_USER_GROUP = "GET_USER_GROUP";
export const GET_USER_GROUP_SUCCESS = "GET_USER_GROUP_SUCCESS";
export const GET_USER_GROUP_ERROR = "GET_USER_GROUP_ERROR";

export const POST_USER_GROUPS = "POST_USER_GROUPS";
export const POST_USER_GROUPS_SUCCESS = "POST_USER_GROUPS_SUCCESS";
export const POST_USER_GROUPS_ERROR = "POST_USER_GROUPS_ERROR";

export const PATCH_USER_GROUP = "PATCH_USER_GROUP";
export const PATCH_USER_GROUP_SUCCESS = "PATCH_USER_GROUP_SUCCESS";
export const PATCH_USER_GROUP_ERROR = "PATCH_USER_GROUP_ERROR";

export const DELETE_USER_GROUP = "DELETE_USER_GROUP";
export const DELETE_USER_GROUP_SUCCESS = "DELETE_USER_GROUP_SUCCESS";
export const DELETE_USER_GROUP_ERROR = "DELETE_USER_GROUP_ERROR";

// Validation
const validateForm = {
  createUserGroup: (validate, fields, oneField) =>
    validate(fields, oneField) // .prop('name', 'Nazwa').required()
      .getErrors().promise
};

// Requests

const getUserGroupsGet = (fetch, apiHost, accessToken, meta) =>
  fetch(`${apiHost}/v1/user-groups?limit=${meta.limit}&offset=${meta.offset}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const getUserGroupGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v2/user-groups/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postUserGroups = (fetch, apiHost, accessToken, data) =>
  fetch(`${apiHost}/v1/user-groups`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchUserGroup = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/user-groups/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteUserGroup = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/user-groups/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg:
          "Nie można usunąć danych grup użytkownika, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions

export function getUserGroups(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_USER_GROUPS],
    payload: {
      promise: getUserGroupsGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          return normalize(data, { userGroups: arrayOf(userGroup) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getUserGroup(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_USER_GROUPS],
    payload: {
      promise: getUserGroupGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, userGroup);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        }),
      data: {
        uid
      }
    }
  });
}

export function createUserGroup(data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_USER_GROUPS],
    payload: {
      promise: validateForm["createUserGroup"](validate, data)
        .then(() =>
          postUserGroups(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data
          )
        )
        .then(data => {
          return normalize(data, userGroup);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateUserGroup(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_USER_GROUP],
    payload: {
      promise: patchUserGroup(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, userGroup);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeUserGroup(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_USER_GROUP],
    payload: {
      promise: deleteUserGroup(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

// Standard functions
export function validateFormFieldUserGroups(form, name, value) {
  const feature = "userGroups";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/userGroups/actions.js